import React from 'react'
import Link from 'gatsby-link'
import { Container, Row, Col, Button, Nav, NavItem, NavLink } from 'reactstrap'
import browserStats from './images/graphics/undraw_browser_stats_704t.svg'
import work from './images/working.jpg'
import Referenzen from '../components/referenzen';

const IndexPage = ({ data }) => (
  <div>
    <section className="bg evelope">
      <Container>
        <Row className="align-items-center py-5 py-md-7 py-lg-8">
          <Col xs="9" md="6">
            <h1>Maßgeschneiderte Software für Ihr Unternehmen.</h1>
            <p className="lead my-5">
              Ich helfe Ihnen dabei Ihre Ideen und Projekte in benutzerfreundliche und hochwertige Software zu verwandeln.
            </p>
            <Button color="primary" size="lg" tag={Link} to="/referenzen">Referenzen ansehen</Button>
          </Col>
          <Col xs="3" md="6">
            <img src={browserStats} className="img-fluid p-md-0" alt="Maßgeschneiderte Software" />
          </Col>
        </Row>
      </Container>
    </section>
    
    <section className="sls-block">
      <div className="bg-image left-40 d-none d-md-block" style={{backgroundImage: `url(${work})`}}>
      </div>

      <Container>
        <Row className="py-7 justify-content-end">
          <Col md="7">
            <Row>
              <Col>
                <h2>Vom Problem zur Lösung.</h2>
                <p className="lead mt-5">
                  Mit hohen Ansprüchen, modernen Werkzeugen und einem Auge für Details arbeite ich seit 
                  Jahren gemeinsam mit und für meine Kunden und konnte dadurch bereits eine Vielzahl an 
                  Projekten erfolgreich umsetzen.
                </p>
              </Col>
            </Row>

            <Row>
              <Col xs="6" className="mt-5">
                <h6 className="text-uppercase">Webapplikationen</h6>
                <Nav vertical>
                  <NavItem>
                    <NavLink to="/leistungen" tag={Link}>Elixir / Phoenix</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/leistungen" tag={Link}>Java / Spring Boot</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/leistungen" tag={Link}>PHP / Laravel</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/leistungen" tag={Link}>Python</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/leistungen" tag={Link}>JavaScript / React</NavLink>
                  </NavItem>
                </Nav>
              </Col>

              <Col xs="6" className="mt-5">
                <h6 className="text-uppercase">Webseiten</h6>
                <Nav vertical>
                  <NavItem>
                    <NavLink to="/leistungen" tag={Link}>OctoberCMS</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/leistungen" tag={Link}>Wordpress</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/leistungen" tag={Link}>GatsbyJS</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/leistungen" tag={Link}>Bootstrap</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/leistungen" tag={Link}>JQuery</NavLink>
                  </NavItem>
                </Nav>
              </Col>

              <Col xs="6" className="mt-5">
                <h6 className="text-uppercase">Datenbanken</h6>
                <Nav vertical>
                  <NavItem>
                    <NavLink to="/leistungen" tag={Link}>PostgreSQL</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/leistungen" tag={Link}>MySQL</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/leistungen" tag={Link}>Oracle</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/leistungen" tag={Link}>DynamoDB</NavLink>
                  </NavItem>
                </Nav>
              </Col>

              <Col xs="6" className="mt-5">
                <h6 className="text-uppercase">Anwendungssoftware</h6>
                <Nav vertical>
                  <NavItem>
                    <NavLink to="/leistungen" tag={Link}>C# / WPF</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/leistungen" tag={Link}>Java / JavaFX</NavLink>
                  </NavItem>
                </Nav>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>

    <section className="py-md-8">
      <Container>
        <h2>Use-Cases und Referenzprojekte.</h2>

        <Row className="pb-7">
          <Col lg="6" className="pt-5">
            <p className="lead">
              Bilder sagen mehr als Worte. Das gilt auch für Projekte, die bereits umgesetzt wurden. Machen Sie sich selbst ein Bild.
            </p>
          </Col>
          <Col lg="6" className="pt-5">
            <h6 className="text-uppercase">Ausgewählte Use-Cases</h6>
            <ul className="list-styled">
              {data.allMarkdownRemark.edges.map(({ node: reference }) =>
                <li key={reference.frontmatter.path}><Link to={reference.frontmatter.path}>{reference.frontmatter.title}</Link></li>
              )}
            </ul>

            <Link to="/referenzen" className="border-bottom py-1">Weitere Use-Cases und Referenzen anzeigen</Link>
          </Col>
        </Row>

        <Referenzen />
      </Container>
    </section>
  </div>
)

export const referencesQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          id
          frontmatter {
            title
            company
            path
          }
        }
      }
    }
  }
`;

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js